import { InlineChart } from '@/components/ai/chat/InlineChart';
import type { DashboardChartConfig, DashboardChartData } from '@pm-next/shared-types';
import { useMemo } from 'react';

interface ChartBlockProps {
  data: DashboardChartData;
  chartConfig?: DashboardChartConfig | null;
}

export function ChartBlock({ data, chartConfig }: ChartBlockProps) {
  const resolvedConfig = chartConfig ?? data.chartConfig ?? null;
  const code = useMemo(
    () =>
      JSON.stringify({
        type: data.type,
        data: data.data,
        ...(data.series ? { series: data.series } : {}),
        ...(data.seriesLabels ? { seriesLabels: data.seriesLabels } : {}),
      }),
    [data]
  );

  return (
    <div className="w-full">
      <InlineChart
        code={code}
        showTitle={false}
        bare
        chartHeightClassName="h-[280px]"
        className="w-full"
        chartConfig={resolvedConfig}
      />
    </div>
  );
}
